package com.appsyde.shared.modules.team.domain.model

data class TeamInvite(
    val id: String,
    val email: String,
    val expiresAt: String,
    val usedAt: String?,
    val revokedAt: String?,
    val createdAt: String
)
